import apiSlice from "../apiSlice";

export const invitationApi = apiSlice.injectEndpoints({
    endpoints: builder => ({
        createInvitation: builder.mutation({
            query: payload => ({
                url: '/invitation/',
                method: 'POST',
                body: payload
            })
        }),
        listInvitations: builder.query({
            query: () => ({ url: '/invitation/' })
        }),
        getInvitation: builder.query({
            query: (payload) => ({ url: `/invitation/${payload.token}` })
        }),
    })
});
export const { useGetInvitationQuery, useCreateInvitationMutation, useListInvitationsQuery, } = invitationApi;